@if (isLoaded()) {
  <div class="time-form container flex justify-center flex-column">
    <p>Select the date and time that works for you.</p>
    <form [formGroup]="formGroup" id="time-form">
      <div class="dropdown">
        <img src="icons/calendar.svg" class="icon" />
        <mat-form-field appearance="fill" class="w-100 flex-1">
          <mat-label>Date</mat-label>
          <mat-select formControlName="date">
            @for (date of days(); track date) {
              <mat-option [value]="date">{{ date }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="dropdown">
        <img src="icons/clock.svg" class="icon" />
        <mat-form-field appearance="fill" class="w-100 flex-1">
          <mat-label>Time</mat-label>
          <mat-select formControlName="time">
            @for (
              time of groupedSlots()[formGroup.controls.date.value ?? ""];
              track $index
            ) {
              <mat-option [value]="$index">
                {{ time.from | date: "HH:mm" }} - {{ time.to | date: "HH:mm" }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <button
        type="button"
        class="primary-button"
        (click)="save()"
        [disabled]="formGroup.invalid || !allowPreferredDateConfirmation()"
      >
        Confirm time
      </button>
    </form>
  </div>
}
